import {Component, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {catchError, EMPTY, from, Subscription, switchMap, take, tap} from 'rxjs';
import {GgAuthService, ILoginState} from '../../services/gg-auth.service';
import {AuthService} from '../../../../services/api/auth.service';
import {TokenService} from '../../../../services/token.service';
import {AlertService} from '../../../../services/notify/alert.service';
import {MemberService} from '../../../../services/member.service';
import {TFormState} from '../../../../models/forms.model';

@Component({
    selector: 'app-gg-login-form',
    templateUrl: './gg-login-form.component.html',
    styleUrl: './gg-login-form.component.scss'
})
export class AppGgLoginFormComponent implements OnDestroy {
    subscriptions = new Subscription;
    public loginForm: FormGroup;
    public formState: TFormState = 'Default';
    private loginStateObj: ILoginState = {state: 'login'};
    public hidePassword: Boolean = true;
    loading = {
        login: false,
        register: false,
    };
    lastPage: string = '';

    constructor(
        private fb: FormBuilder,
        private ggAuthService: GgAuthService,
        private authService: AuthService,
        private alertService: AlertService,
        private tokenService: TokenService,
        private activatedRoute: ActivatedRoute,
        private translateService: TranslateService,
        private memberService: MemberService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.loginForm = fb.group({
            email: ['', {validators: [Validators.required, Validators.email], updateOn: 'blur'}],
            passwd: ['', [Validators.required]],
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    authenticateUser() {
        this.formState = 'Submitting';
        this.subscriptions.add(
            this.authService.login(this.loginForm.value)
                .pipe(
                    tap(data => {
                        if (data.member.lang) {
                            this.translateService.use(data.member.lang);
                            localStorage.setItem('language', data.member.lang);
                        }
                        this.loginStateObj.token = data.access_token;
                        this.tokenService.setToken(data.access_token, data.expires_in);
                    }),
                    switchMap(() => from(this.memberService.getCurrentMember(true))),
                    take(1),
                    catchError(err => {
                        this.alertService.setAlert(err.message, 'blue');
                        this.formState = 'Default';
                        return EMPTY;
                    }))
                .subscribe(() => {
                    this.formState = 'Default';
                    this.tokenService.startTimer();
                    let redirectPage = this.route.snapshot?.queryParams?.lastpage || 'account/index';
                    this.router.navigate([redirectPage], this.route.snapshot.params);
                })
        );
    }

    goToActivateAccount() {
        this.ggAuthService.loginStateSub.next({state: 'activate'});
    }

    get password() {
        return this.loginForm.get('passwd');
    }

    get email() {
        return this.loginForm.get('email');
    }
}
